import { render } from "./CompetitorsLogErro.vue?vue&type=template&id=3d2ecd1a&scoped=true&ts=true"
import script from "./CompetitorsLogErro.vue?vue&type=script&lang=ts"
export * from "./CompetitorsLogErro.vue?vue&type=script&lang=ts"

import "./CompetitorsLogErro.vue?vue&type=style&index=0&id=3d2ecd1a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2ecd1a"]])

export default __exports__